module.exports = __webpack_public_path__ + "img/23.900ce5ab.jpg";